@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
<div class="grid-layout my-clubs" data-infinite-scroll="List.nextPage()" data-infinite-scroll-distance="0">
  <div class="row clearfix max-width">
    <div class="small-12 columns account-row">
      <a (click)="navigate('/Users/my-profile')" title="">
        <span class="fa fa-fw fa-arrow-left"></span> Back to My Account
      </a>
    </div>
  </div>
  <div class="row clearfix max-width">
    <div class="small-12 columns">
      <div>
        <h2>My Clubs</h2>
      </div>
    </div>
  </div>

  @if (clubs && !clubs.length) {
    <div class="small-12 columns">
      You are not part of any clubs.
    </div>
  }
  @for (club of clubs; track club) {
    <div class="item {{club.data.colour_scheme}}">
      <div class="item-contents" (click)="navigate('/company/' + club.data.company_slug)">
        <div class="image" [ngStyle]="{'background-image': 'url(' + club.data.s3_thumbnail_url + ')'}">
          @if (club.data.badge) {
            <div class="badged">
              {{ club.data.badge }}
            </div>
          }
        </div>
        <div class="description">
          <h3>{{ club.data.menu_title }}</h3>
        </div>
        <div class="item-price" [ngClass]="{expired: !club.data.isMember}">
          <div>
            <p>
              Partnership Club Page<span>{{
              (club.data.isMember && 'Joined') || 'Expired'
            }}</span>
          </p>
        </div>
        <div class="view-details">
          <p>View Details <span class="fa fa-chevron-circle-right"></span></p>
        </div>
      </div>
    </div>
  </div>
}
</div>